import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import withModal from '../../../../lib/hoc/withModal';
import SearchTagListModal from '../../../../views/widget/common/modal/SearchTagListModal';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { appActions } from '../../../../store/modules/app';
import { widgetActions } from '../../../../store/modules/widget';
import { comparePrePropsAndNextProps } from '../../../../lib/common';

class SearchTagModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  선택된 태그
       */
      selectedTagList: [],
      /**
       *  선택된 태그 ID
       */
      selectedTagIdList: props.data.selectedId ? [props.data.selectedId] : [],
    };
  }

  componentDidMount() {
    this.initiate(this.props.data.selectedId);
  }

  componentDidUpdate(prevProps) {
    if (comparePrePropsAndNextProps([[prevProps.data.selectedItem, this.props.data.selectedItem]])) {
      this.setState({
        selectedTagList: [this.props.data.selectedItem],
      });
    }
  }

  initiate = (tagId) => {
    this.getList({
      tagId,
      pagination: LIST_PAGINATION_MODEL,
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    const { toggleModal } = this.props;

    toggleModal({
      name: 'searchTagListModal',
      value: false,
    });
  };

  /**
   *  태그 선택하기
   */
  onSubmit = () => {
    const { selectedTagList, selectedTagIdList } = this.state;
    const { setData, data } = this.props;
    const { targetPath } = data;

    /**
     *  상품 후기가 선택 되었는지 체크
     */
    if (!selectedTagIdList[0]) {
      message.error('상품 후기를 선택해주세요.');
      return;
    }

    setData({
      path: [...targetPath, 'linkId'],
      value: selectedTagIdList[0],
    });

    setData({
      path: [...targetPath, 'linkName'],
      value: selectedTagList[0].name,
    });

    this.closeModal();
  };

  /**
   *  태그 리스트 가져오기
   */
  getList = (option) => {
    const { getTagList, data } = this.props;
    const { listPath, listData } = data;
    const { filterOption, sortOption, pagination } = listData;

    getTagList({
      filterOption,
      sortOption,
      pagination,
      ...option,
      listPath,
    });
  };

  /**
   *  태그 선택 callback
   */
  onCheckTag = (list) => {
    const { selectedTagIdList } = this.state;
    const { listData } = this.props.data;
    let targetIdList = list;

    if (list.length > 1) {
      targetIdList = list.filter((id) => id !== selectedTagIdList[0]);
    }

    const targetList = listData.list.filter((item) => targetIdList.includes(item.id));

    this.setState({
      /**
       *  선택된 태그
       */
      selectedTagList: targetList,
      /**
       *  선택된 태그 ID
       */
      selectedTagIdList: targetIdList,
    });
  };

  render() {
    return (
      <SearchTagListModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        closeModal={this.closeModal}
        getTagList={this.getList}
        onCheckTag={this.onCheckTag}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.widget.searchTagListModal.isOpen,
    data: state.widget.searchTagListModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: widgetActions.toggleModal,
  setData: widgetActions.setData,
  getTagList: widgetActions.getTagList,
  getRelatedTagList: appActions.getRelatedTagList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(SearchTagModalContainer));
